<template>
  <form @submit.prevent="onSubmit">
    <p v-if="errors.length">Please correct the following error(s):
        <ul>
            <li v-for="error in errors">{{error}}</li>
        </ul>
    </p>
    <div class="form-group"><label class="text-muted">Office:</label>
        <location-select class="form-control" name="office" required="required" type="office" v-model="form.officeId" :class="errors.officeId ? 'is-invalid' : ''"></location-select>
        <div class="invalid-feedback" v-if="errors.officeId">{{ errors.officeId[0] }}</div>
    </div>
    <div class="form-group"><label class="text-muted">Message:</label><textarea class="form-control" name="message" required="required" v-model="form.message" :class="errors.message ? 'is-invalid' : ''"></textarea>
        <div class="invalid-feedback" v-if="errors.message">{{ errors.message[0] }}</div>
    </div>
    <div class="form-group">
        <img src="@/assets/images/YouTube_Logo.png" />
        <div><span class="font-weight-bold youtubeTitle">How to Embed a YouTube Video</span>
            <p> When viewing the youtube video, click share, then click embed, then copy and paste here.</p>
        </div>
    </div>
    <div class="form-group text-right">
        <b-btn class="mr-2" size="sm" variant="success" type="submit" value="submit">create</b-btn>
        <b-btn size="sm" @click="cancel()">Cancel</b-btn>
    </div>
</form>
</template>

<script>
import LocationSelect from '@/components/LocationSelect'
import api from '@/http'

export default {
  name: 'OfficeMessageForm',

  components: {
    LocationSelect
  },

  data () {
    return {
      form: {
        officeId: null,
        message: ''
      },

      errors: {}
    }
  },

  methods: {
    async onSubmit () {
      try {
        this.busy = true
        this.errors = []
        await api.postRequest('api/v1/office-message', this.form)
        this.$emit('success')
      } catch (err) {
        if (err.response.status === 422) {
          this.errors = err.response.data.errors
        } else {
          throw err
        }
      } finally {
        this.busy = false
      }
    },

    reset () {
      this.form = {
        officeId: null,
        message: ''
      }
    },

    cancel () {
      this.$emit('close')
      this.reset()
    }
  }
}
</script>

<style scoped>
  .youtubeTitle {
    color: #7b009c;
  }
</style>
